import { cn } from './cn'

export interface EmptyStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
	icon?: React.ReactNode
	title: React.ReactNode
	description?: React.ReactNode
	action?: React.ReactNode
}

export function EmptyState({ icon, title, description, action, className, ...rest }: EmptyStateProps) {
	return (
		<div className={cn('flex flex-col items-center text-center py-12 px-6', className)} {...rest}>
			{icon && (
				<div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4 bg-base-200 text-base-content/50">
					{icon}
				</div>
			)}
			<p className="text-lg font-semibold mb-1">{title}</p>
			{description && <p className="text-sm text-base-content/60 max-w-sm mb-5">{description}</p>}
			{action}
		</div>
	)
}
